<script setup lang="ts">
defineProps<{
  src: string;
  withoutBackground?: boolean;
}>();
</script>

<template>
  <img
    :src="src"
    class="aspect-square rounded-sm object-cover"
    :class="{
      'border border-slate-200': !withoutBackground,
    }"
  />
</template>
